module.exports = __webpack_public_path__ + "static/media/Vaibhav.7d82c6ad.png";